import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";

export const useGetStudents = (organizationId: string) => {
  const studentsService = useServices().studentsService;
  return useQuery({
    queryKey: ['organizationStudents', organizationId],
    queryFn: () => studentsService.getStudents(organizationId),
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
  });
};